import { IconButton } from "@overmap-ai/blocks"
import { type ComponentPropsWithRef, memo, useMemo } from "react"

interface ColorButtonProps extends Omit<ComponentPropsWithRef<typeof IconButton>, "variant" | "accentColor"> {
	color: string
}

export const ColorButton = memo<ColorButtonProps>((props) => {
	const { ref, style, color, ...rest } = props

	const computedStyle = useMemo(
		() => ({
			...style,
			background: color,
		}),
		[color, style],
	)

	return <IconButton ref={ref} style={computedStyle} variant="solid" {...rest} />
})
ColorButton.displayName = "ColorButton"
